import { render, staticRenderFns } from "./IconDotsHorizontal.vue?vue&type=template&id=81244f84&scoped=true"
import script from "./IconDotsHorizontal.vue?vue&type=script&lang=js"
export * from "./IconDotsHorizontal.vue?vue&type=script&lang=js"
import style0 from "./IconDotsHorizontal.vue?vue&type=style&index=0&id=81244f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81244f84",
  null
  
)

export default component.exports